import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  CreateMedia,
  GetProductStatus,
  GetSubcategoriesProductsData,
} from "../apiconfig/authService";
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";

function AddMedia(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaImage, setMediaImage] = useState(null);
  const [urlLink, setUrlLink] = useState("");
  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [subCategoryID, setSubCategoryID] = useState("");
  const [subCategoriesData, setSubCategoriesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [categoryID, setCategoryID] = useState("");
  const [loading, setLoading] = useState(false);

  const dropdownRef = useRef(null);

  // Remove duplicates by name before filtering
  const uniqueSubcategories = Array.from(
    new Map(subCategoriesData.map((item) => [item.name, item])).values()
  );

  // Remove duplicates by name first, THEN filter
  const filteredSubcategories = Array.from(
    new Map(subCategoriesData.map((item) => [item.name, item])).values()
  ).filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!mediaTitle.trim()) {
        toast.error("Media title is required!");
        return;
      }
      if (mediaImage === null) {
        toast.error("Image is required!");
        return;
      }
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(mediaImage.type)) {
        toast.error("Only JPG, JPEG, and PNG images are allowed!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", mediaTitle);
      formData.append("Image", mediaImage);
      formData.append("statusid", statusid);
      formData.append("subcategoryid", subCategoryID);
      formData.append("categoryid", categoryID);
      formData.append("urlLink", urlLink);
      setLoading(true);
      const response = await CreateMedia(
        formData,
        localStorage.getItem("accessToken")
      );

      if (response.status === 201) {
        setLoading(false);
        setMediaTableViewMessage("Media Added Successfully");
        toast.success(response?.data?.message);
        navigate("/media");
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          "An error occurred. Please try again later."
      );
      window.scrollTo(0, 0);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSubCategory = (item) => {
    setSubCategoryID(item.subcategoryid);
    setCategoryID(item.categoryid);
    setSearchTerm(item.name);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const subcategoriesResponse = await GetSubcategoriesProductsData(
          localStorage.getItem("accessToken")
        );
        setSubCategoriesData(
          subcategoriesResponse.data.subCategoriesItems || []
        );
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Media</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* Media Title & Image */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label>Media Title</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={mediaTitle}
                onChange={(e) => setMediaTitle(e.target.value)}
                className="form-control custom-input my-2"
                placeholder="Media Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label>Media Image</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="file"
                className="form-control custom-input my-2"
                onChange={(e) => setMediaImage(e.target.files[0])}
                accept="image/*"
              />
            </div>
          </div>

          {/* URL Link & Status */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label>URL Link</label>
              <input
                type="text"
                value={urlLink}
                onChange={(e) => setUrlLink(e.target.value)}
                className="form-control custom-input my-2"
                placeholder="URL Link"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label>Status</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <select
                className="form-select custom-input my-2"
                onChange={(e) => setStatusid(e.target.value)}
                value={statusid}
              >
                {statusData?.map((item) => (
                  <option key={item.statusid} value={item.statusid}>
                    {item.status}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Searchable Dropdown for Screen Type */}
          <div className="form-group col-sm-12 col-lg-6 mb-3" ref={dropdownRef}>
            <label>Screen Type</label>
            <div className="position-relative">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setIsDropdownOpen(true);
                }}
                onClick={() => setIsDropdownOpen(true)}
                placeholder="Search screen type..."
                className="form-control custom-input my-2"
              />

              {isDropdownOpen && (
                <div
                  className="border rounded bg-white position-absolute w-100 mt-1"
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    zIndex: 999,
                  }}
                >
                  {filteredSubcategories.length > 0 ? (
                    filteredSubcategories.map((item) => (
                      <div
                        key={item._id}
                        className="px-3 py-2 dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSelectSubCategory(item)}
                      >
                        {item.name}
                      </div>
                    ))
                  ) : (
                    <div className="px-3 py-2 text-muted">No results found</div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Submit */}
          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  onClick={handleSubmitClick}
                  disabled={loading}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}

export default AddMedia;
